import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

const teamMembers = [
  {
    name: '林婉儿',
    role: '创始人 & 主编',
    bio: '前时尚杂志资深编辑，十年女性生活方式内容创作经验。坚信每个女人都有属于自己的独特魅力，致力于帮助更多女性发现并展现这份美。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20professional%20Chinese%20woman%20portrait%20with%20warm%20smile%2C%20minimalist%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20portrait%20photography&width=400&height=400&seq=team-01&orientation=squarish',
  },
  {
    name: '苏雨晴',
    role: '首席造型师',
    bio: '国际认证形象顾问，曾为多位明星和企业家提供私人造型服务。擅长根据个人身材和气质打造独一无二的性感风格。',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20Chinese%20woman%20portrait%20with%20fashionable%20outfit%2C%20minimalist%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20portrait%20photography&width=400&height=400&seq=team-02&orientation=squarish',
  },
  {
    name: '陈思雅',
    role: '美妆总监',
    bio: '知名美妆博主，拥有超过50万粉丝。精通各类妆容技法，尤其擅长亚洲女性的日常妆和晚宴妆设计。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20woman%20portrait%20with%20natural%20makeup%2C%20minimalist%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20beauty%20photography&width=400&height=400&seq=team-03&orientation=squarish',
  },
];

const testimonials = [
  {
    name: '小雅',
    city: '上海',
    text: '关注魅力养成已经一年多了，从穿搭到气质提升的每一篇文章都让我受益匪浅。现在朋友们都说我整个人变得更有魅力了，感谢！',
    rating: 5,
  },
  {
    name: 'Linda',
    city: '北京',
    text: '作为一个职场新人，穿搭一直是我的痛点。通过魅力养成的穿搭指南，我现在每天都能自信地走进办公室。强烈推荐给所有女生！',
    rating: 5,
  },
  {
    name: '晓婷',
    city: '广州',
    text: '最喜欢的是气质提升系列，特别是那篇7天气质蜕变计划，我跟着练习了三周，效果真的惊人！体态、谈吐、眼神全部都变了。',
    rating: 5,
  },
  {
    name: 'Amber',
    city: '深圳',
    text: '妆容教程太实用了！以前化烟熏妆总是变熊猫眼，按照教程里的轻烟熏画法试了一次，同事都问我是不是去进修了化妆课程。',
    rating: 5,
  },
  {
    name: '思思',
    city: '成都',
    text: '不只是教你怎么穿、怎么化妆，更让我学会了从内而外地喜欢自己。这种自信的感觉才是真正持久的魅力，谢谢你们！',
    rating: 5,
  },
  {
    name: 'Mia',
    city: '杭州',
    text: '每一篇文章质量都超高，不像那些水内容的公众号。能感受到团队是真的用心在做内容，希望能一直保持这样的品质！',
    rating: 5,
  },
];

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="pt-16 md:pt-18">
        <Breadcrumb
          items={[
            { label: '关于我们' },
          ]}
        />

        {/* Hero */}
        <section className="relative w-full min-h-[300px] md:min-h-[380px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20workspace%20with%20fashion%20magazines%20and%20beauty%20products%2C%20warm%20cream%20and%20beige%20tones%2C%20soft%20natural%20lighting%2C%20editorial%20lifestyle%20photography&width=1600&height=700&seq=about-hero-01&orientation=landscape"
            alt="关于我们 - 美女性感魅力养成指南"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30" />
          <div className="relative z-10 w-full text-center px-4 md:px-6">
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-white mb-3">
              关于我们
            </h1>
            <p className="text-sm md:text-base text-white/85 max-w-xl mx-auto">
              一群热爱美、追求美的女性，用专业和热情帮助你成为更好的自己
            </p>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                我们的故事
              </h2>
              <div className="w-12 h-0.5 bg-accent-500 mx-auto" />
            </div>
            <div className="space-y-5 text-foreground-700 leading-relaxed">
              <p>
                <strong className="text-foreground-900">美女性感魅力养成指南</strong>诞生于2023年，由一群深耕时尚、美妆和女性成长领域的专业人士共同创立。
              </p>
              <p>
                我们的创始人林婉儿曾在时尚杂志社担任资深编辑长达十年。在这十年间，她接触了无数女性读者，发现一个共性问题：很多女性觉得自己"不够美"、"不够性感"，但却不知道从哪里开始改变。她们需要的不是空洞的鸡汤，而是切实可行的方法论——从穿搭技巧到妆容手法，从体态训练到气质培养。
              </p>
              <p>
                于是，魅力养成指南应运而生。我们不做表面的时尚资讯搬运工，而是深耕每一篇内容，确保读者读完后能真正学到东西、用到生活中。每篇文章的背后，都凝聚着造型师、化妆师和心理学顾问的专业智慧。
              </p>
              <p>
                我们坚信：<strong className="text-foreground-900">性感不是少数人的特权，而是每个女人都可以通过学习和练习获得的能力。</strong>它不在于你的身材尺寸、不在于你的年龄大小，而在于你是否了解自己、接纳自己，并懂得如何展现自己最美的一面。
              </p>
              <p>
                从2023年至今，我们已经帮助超过<strong className="text-accent-600">十万名女性</strong>找到了属于自己的魅力密码。未来，我们将继续深耕内容，拓展更多领域，陪伴每一位女性在变美的路上越走越远。
              </p>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                核心团队
              </h2>
              <p className="text-sm text-foreground-600">
                专业、热情、有爱的团队，为你提供最优质的内容
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              {teamMembers.map((member) => (
                <div
                  key={member.name}
                  className="text-center bg-background-50 rounded-lg p-6 border border-background-200/70"
                >
                  <div className="w-24 h-24 md:w-28 md:h-28 rounded-full overflow-hidden mx-auto mb-4">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-1">
                    {member.name}
                  </h3>
                  <p className="text-sm text-accent-600 font-medium mb-3">{member.role}</p>
                  <p className="text-sm text-foreground-600 leading-relaxed">{member.bio}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section id="testimonials" className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                用户口碑
              </h2>
              <p className="text-sm text-foreground-600">
                听听她们怎么说
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {testimonials.map((testimonial, index) => (
                <div
                  key={index}
                  className="bg-background-50 border border-background-200/70 rounded-lg p-5"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: testimonial.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm" />
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "{testimonial.text}"
                  </p>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-xs font-medium text-primary-700">
                        {testimonial.name[0]}
                      </span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{testimonial.name}</p>
                      <p className="text-xs text-foreground-500">{testimonial.city}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-2xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                联系我们
              </h2>
              <p className="text-sm text-foreground-600">
                有任何问题、建议或合作意向？欢迎随时与我们取得联系
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
              <div className="text-center p-5 bg-background-50 rounded-lg border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                  <i className="ri-mail-line text-lg" />
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                <p className="text-xs text-foreground-600">hello@charmguide.com</p>
              </div>
              <div className="text-center p-5 bg-background-50 rounded-lg border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                  <i className="ri-wechat-line text-lg" />
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</h3>
                <p className="text-xs text-foreground-600">魅力养成指南</p>
              </div>
              <div className="text-center p-5 bg-background-50 rounded-lg border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-200 text-secondary-700 mx-auto mb-3">
                  <i className="ri-time-line text-lg" />
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">工作时间</h3>
                <p className="text-xs text-foreground-600">周一至周五 9:00-18:00</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "关于我们 - 美女性感魅力养成指南",
          "description": "了解美女性感魅力养成指南的品牌故事、核心团队和用户口碑。我们致力于帮助每一位女性发现并展现属于自己的独特魅力。",
          "url": "https://yourdomain.com/about",
          "inLanguage": "zh-CN",
          "isPartOf": {
            "@type": "WebSite",
            "name": "美女性感魅力养成指南",
            "url": "https://yourdomain.com/"
          },
          "about": {
            "@type": "Organization",
            "name": "美女性感魅力养成指南",
            "foundingDate": "2023",
            "description": "专注女性魅力养成的时尚生活方式平台",
            "contactPoint": {
              "@type": "ContactPoint",
              "contactType": "customer service",
              "email": "hello@charmguide.com",
              "availableLanguage": ["Chinese"]
            }
          }
        })
      }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "首页",
              "item": "https://yourdomain.com/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "关于我们",
              "item": "https://yourdomain.com/about"
            }
          ]
        })
      }} />
    </>
  );
}